import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";

interface BackdropLoaderProps {
    progress?: number | null;
}

export default function BackdropLoader({ progress = null }: BackdropLoaderProps) {
    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, flexDirection: 'column' })}
            open
        >
            <CircularProgress color="inherit" />
            {progress !== null && (
                <Box mt={2}>
                    <Typography variant="h6" align="center">
                        Uploading file... {progress}%
                    </Typography>
                </Box>
            )}
        </Backdrop>
    );
}
